import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { ChevronUpIcon } from "mds/icons";
import { ChevronDownIcon } from "mds/icons/ChevronDown";

interface BlockMoveButtonsProps {
  onMoveUp: () => void;
  onMoveDown: () => void;
  reachedTop: boolean;
  reachedBottom: boolean;
}

export const BlockMoveButtons: FC<BlockMoveButtonsProps> = ({
  onMoveUp,
  onMoveDown,
  reachedTop,
  reachedBottom,
}) => (
  <>
    {onMoveUp && (
      <SquareIconButton
        className="mb-0.5"
        disabled={reachedTop}
        kind="secondary"
        size="s"
        title={t("tooltip.move_up")}
        onClick={onMoveUp}
      >
        <ChevronUpIcon className={clsx(reachedTop && "text-black-tint-70")} />
      </SquareIconButton>
    )}

    {onMoveDown && (
      <SquareIconButton
        disabled={reachedBottom}
        kind="secondary"
        size="s"
        title={t("tooltip.move_down")}
        onClick={onMoveDown}
      >
        <ChevronDownIcon className={clsx(reachedBottom && "text-black-tint-70")} />
      </SquareIconButton>
    )}
  </>
);
